var AssetDirectory = {
	"load": [
		"assets/.DS_Store",
		"assets/bgm/cakematch.ogg",
		"assets/bgm/yummy.ogg",
		"assets/fonts/airbagfree-regular.woff",
		"assets/fonts/londonbetween.woff",
		"assets/htp/htp_cm1.png",
		"assets/htp/htp_cm2.png",
		"assets/htp/htp_cm3.png",
		"assets/htp/htp_cm4.png",
		"assets/htp/htp_cm5.png",
		"assets/ingame/cake_01.png",
		"assets/ingame/cake_02.png",
		"assets/ingame/cake_03.png",
		"assets/ingame/cake_04.png",
		"assets/ingame/cake_05.png",
		"assets/ingame/cake_06.png",
		"assets/ingame/cake_07.png",
		"assets/ingame/cake_08.png",
		"assets/ingame/cake_09.png",
		"assets/ingame/cake_10.png",
		"assets/ingame/cake_11.png",
		"assets/ingame/cake_12.png",
		"assets/ingame/cake_13.png",
		"assets/ingame/cake_14.png",
		"assets/ingame/cake_15.png",
		"assets/ingame/cake_16.png",
		"assets/ingame/cake_17.png",
		"assets/ingame/cake_18.png",
		"assets/ingame/cake_19.png",
		"assets/ingame/cake_20.png",
		"assets/ingame/cm_bg.png",
		"assets/ingame/cm_gizmo.png",
		"assets/ingame/cm_ui_matchpopup.png",
		"assets/ingame/donut_01.png",
		"assets/ingame/donut_02.png",
		"assets/ingame/donut_03.png",
		"assets/ingame/fx_glow_selected.png",
		"assets/ingame/fx_megabonus.png",
		"assets/ingame/fx_sparkle.png",
		"assets/ingame/fx_sparkle_ske.json",
		"assets/ingame/fx_sparkle_tex.json",
		"assets/ingame/fx_sparkle_tex.png",
		"assets/ingame/popsicle_01.png",
		"assets/ingame/popsicle_02.png",
		"assets/ingame/popsicle_03.png",
		"assets/sfx/bonus.ogg",
		"assets/sfx/button_sfx.ogg",
		"assets/sfx/correct.ogg",
		"assets/sfx/ding.ogg",
		"assets/sfx/score_points.ogg",
		"assets/sfx/select.ogg",
		"assets/sfx/star_gain.ogg",
		"assets/sfx/tic.ogg",
		"assets/sfx/toc.ogg",
		"assets/sfx/wrong.ogg",
		"assets/titlescreen/cm_title_cake_01.png",
		"assets/titlescreen/cm_title_cake_02.png",
		"assets/titlescreen/cm_title_cake_03.png",
		"assets/titlescreen/cm_title_cake_04.png",
		"assets/titlescreen/cm_title_logo.png",
		"assets/ui/btn_audio1.png",
		"assets/ui/btn_audio2.png",
		"assets/ui/btn_audio3.png",
		"assets/ui/btn_audio4.png",
		"assets/ui/btn_close.png",
		"assets/ui/btn_exit.png",
		"assets/ui/btn_exit2.png",
		"assets/ui/btn_pause.png",
		"assets/ui/btn_pause2.png",
		"assets/ui/btn_play.png",
		"assets/ui/btn_play2.png",
		"assets/ui/btn_prevnext.png",
		"assets/ui/btn_prevnext2.png",
		"assets/ui/btn_return.png",
		"assets/ui/btn_return2.png",
		"assets/ui/check-button1.png",
		"assets/ui/check-button2.png",
		"assets/ui/cm_ui_meter_green.png",
		"assets/ui/cm_ui_meter_mid_ctn.png",
		"assets/ui/cm_ui_meter_orange.png",
		"assets/ui/cm_ui_meter_red_mid.png",
		"assets/ui/cm_ui_meter_red_top.png",
		"assets/ui/cm_ui_meter_top_ctn.png",
		"assets/ui/cm_ui_meter_yellow.png",
		"assets/ui/cm_ui_meter_yellowgreen.png",
		"assets/ui/cm_ui_shufflebtn.png",
		"assets/ui/cm_ui_shufflebtn_pressed.png",
		"assets/ui/cm_ui_x5.png",
		"assets/ui/cm_ui_yummyctn.png",
		"assets/ui/gfx_container.png",
		"assets/ui/gfx_container_white.png",
		"assets/ui/gfx_explode.png",
		"assets/ui/gfx_flare_long.png",
		"assets/ui/gfx_flare_star.png",
		"assets/ui/gfx_loading_bar_con.png",
		"assets/ui/gfx_pop.png",
		"assets/ui/gfx_pop2.png",
		"assets/ui/gfx_star0.png",
		"assets/ui/gfx_star1.png",
		"assets/ui/gfx_starbg.png",
		"assets/ui/x-button1.png",
		"assets/ui/x-button2.png"
	],
	"preload": [
		"assets/preload/fonts/Exo-Bold.otf",
		"assets/preload/fonts/Exo-Medium.ttf",
		"assets/preload/fonts/proximanova-black.otf",
		"assets/preload/strings/gizmoloading_ske.json",
		"assets/preload/strings/gizmoloading_tex.json",
		"assets/preload/strings/strings.json",
		"assets/preload/ui/gfx_bg.png",
		"assets/preload/ui/gfx_loading.png",
		"assets/preload/ui/gizmoloading_tex.png"
	],
	"preloadstring": [
		"assets/strings/config.json"
	]
};